import PropTypes from 'prop-types';
import { xingConnect } from '@xingternal/xing-frame-provider';

import selectFooterLinks from './selectors';
import Footer from './Footer';

const connectedFooter = xingConnect(selectFooterLinks)(Footer);
connectedFooter.propTypes = {
  locale: PropTypes.string,
};

export default connectedFooter;
